export const PASSWORD_RULE_TYPE = {
  ONE_LOWER_LETTER: 'ONE_LOWER_LETTER',
  ONE_UPPER_LETTER: 'ONE_UPPER_LETTER',
  ONE_SPECIAL_CHAR: 'ONE_SPECIAL_CHAR',
  MIN_LENGTH: 'MIN_LENGTH'
}

export const PasswordRuleValidator = {
  [PASSWORD_RULE_TYPE.ONE_LOWER_LETTER]: value => /^(?=.*[a-z])/.test(value),
  [PASSWORD_RULE_TYPE.ONE_UPPER_LETTER]: value => /^(?=.*[A-Z])/.test(value),
  [PASSWORD_RULE_TYPE.ONE_SPECIAL_CHAR]: value => /^(?=.*[-+_!@#$%^&*.,?])/.test(value),
  [PASSWORD_RULE_TYPE.MIN_LENGTH]: (value, length = 8) => new RegExp(`^.{${length},}$`).test(value)
}

export function isValidPassword(value) {
  let isValid = true
  const parts = {}
  isValid = (parts[PASSWORD_RULE_TYPE.ONE_LOWER_LETTER] = PasswordRuleValidator[PASSWORD_RULE_TYPE.ONE_LOWER_LETTER](value)) && isValid
  isValid = (parts[PASSWORD_RULE_TYPE.ONE_UPPER_LETTER] = PasswordRuleValidator[PASSWORD_RULE_TYPE.ONE_UPPER_LETTER](value)) && isValid
  isValid = (parts[PASSWORD_RULE_TYPE.ONE_SPECIAL_CHAR] = PasswordRuleValidator[PASSWORD_RULE_TYPE.ONE_SPECIAL_CHAR](value)) && isValid
  isValid = (parts[PASSWORD_RULE_TYPE.MIN_LENGTH] = PasswordRuleValidator[PASSWORD_RULE_TYPE.MIN_LENGTH](value)) && isValid
  return { isValid, parts }
}
